
import { Toast } from 'vant'
import Header from "@/components/header/header.vue";
import { useRoute, useRouter} from "vue-router";
import { ref,inject } from 'vue'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    Header
  },
  
  setup() {
     let logistics: any = ref('')
     let waybill: any = ref('')
     let more_index = ref(0)
     let selectFlag = ref(false)
    const $http: any = inject("$http");
      const route = useRoute()
      const router = useRouter()
    let isShowHeader = ref(true)
    if(route.query.notHeader == '1'){
      isShowHeader.value = !route.query.notHeader
    }
    const getLogistics = async() => {
      let parama = {
        bizOrderNo: route.params.orderNum,
        langType: 'en',
        identity: 1
      }
      // this.$indicator.open()
      let res = await $http.getLogistics(parama).finally(() => {
        // this.$indicator.close()
      })
      if (res.code === 200) {
        logistics.value = res.data
        waybill.value = res.data.waybillList
        if (waybill.value.length == 1) {
          selectFlag.value = true
        }
      } else {
        // 查询不到限制默认订单已创建的状态
        // Toast({
        //   message: res.message,
        //   duration: 3000
        // })
        
        const isNumber = /^\d+$/.test(route.params.orderNum.toString().substring(0, 1))
        console.log(isNumber)
        logistics.value = {
          logisticsOrderNo: isNumber ? route.params.orderNum : ''
        }
        selectFlag.value = true
        waybill.value = [{
          "waybillNo": !isNumber ? route.params.orderNum : '',
          "selfPick": false,
          "receiveName": "Mwan****",
          "receivePhone": "70180****",
          "receiveAddress": "Qwetu Aberdare Heights One \nRoom 562",
          "waybillStatusCode": "100",
          "nodeInfos": [{
            "nodeName": "Ordered",
            "nodeCode": "100",
            "networkId": null,
            "trackingInfo": [{
              "country": "",
              "city": "",
              "networkId": 0,
              "trackingTime": 0,
              "tracking": "The warehouse has received the order.",
              "trackingCode": "103",
              "nodeCode": "100"
            }]
          }]
        }]
      }
    }
    getLogistics()
   const dateFormat  = (i:any) => {
      return (
        new Date(i).toDateString().split(' ')[1] +
        ' ' +
        new Date(i).getDate() +
        ',' +
        new Date(i).getFullYear() +
        ' at ' +
        (new Date(i).getHours() <= 9 ? '0' + new Date(i).getHours() : new Date(i).getHours()) +
        ':' +
        (new Date(i).getMinutes() <= 9 ? '0' + new Date(i).getMinutes() : new Date(i).getMinutes())
      )
    }
    const goPickup  = (id:any) =>{
      router.push('/pickupDetail/' + id)
    }
    const openMore = (i = 0) => {
      if (i != more_index.value) {
        selectFlag.value = true
      } else {
        selectFlag.value = !selectFlag.value
      }
      more_index.value = i
    }
    return {
      openMore,
      goPickup,
      dateFormat,
      getLogistics,
      logistics,
      waybill,
      selectFlag,
      more_index,
      isShowHeader
    }
  }
  
}
